export const RECOMMENDATION_MAP = {
    notRecommended: "Not recommended",
    strong: "Strong recommendation",
    moderate: "Moderate recommendation",
    reasonable: "Reasonable recommendation",
}